type PropertyValueUnion<T extends object> = T[keyof T];

export const buttonSize = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    tall: 'tall',
} as const;

export type ButtonSize = PropertyValueUnion<typeof buttonSize>;

export const buttonVariant = {
    contained: 'contained',
    outline: 'outline',
    text: 'text',
} as const;

export type ButtonVariant = PropertyValueUnion<typeof buttonVariant>;
